import React from 'react';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { gray40 } from '../../../constants/colors';
import { dialogTitle } from '../../../constants/location';
import { useProxyDialogSx } from '../../../hooks/useProxyDialogSx';
import EmailInboxManagement from './EmailInboxManagement';

interface Props {
  open: boolean;
  onClose: () => void;
  /** 操作結果の通知（スナックバーはページ側で表示する） */
  onNotify: (message: string, isError?: boolean) => void;
  /** 発行成功時のコールバック（親側で一覧画面への遷移・再読み込みを行う） */
  onIssued: () => void;
}

// design-rules.md「8. ダイアログ」に準拠。発行フォームを表示する
const styles = {
  dialog: {
    '& .MuiPaper-root': {
      border: '1px solid' + gray40,
      boxSizing: 'border-box',
      margin: '16px',
      // 上下パディングは詰め、横はファイルアップロードダイアログ（UploadModal）と同じ 32px に合わせる
      padding: '20px 32px',
      width: '640px',
      maxWidth: 'calc(100% - 32px)',
      // 本文スクロール＋発行ボタン固定フッターのため Paper を縦フレックスで高さ制限する
      display: 'flex',
      flexDirection: 'column' as const,
      maxHeight: 'calc(100vh - 32px)',
      '@media screen and (max-width:960px)': {
        padding: '20px 16px',
      },
    },
  },
  dialogHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '16px',
    flexShrink: 0,
  },
  dialogTitle,
};

/**
 * メール取り込みの専用アドレス発行ダイアログ。
 * 発行フォームを表示し、発行成功時は onIssued で親がアドレス一覧画面へ遷移・再読み込みする。
 */
const EmailInboxManagementDialog: React.FC<Props> = ({ open, onClose, onNotify, onIssued }) => {
  // 全高ダイアログ（本文スクロール＋固定フッター）のため、代理モードでは maxHeight もバナー分を差し引く
  const proxyDialogSx = useProxyDialogSx({ fullHeight: true });
  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} sx={[styles.dialog, proxyDialogSx]}>
      <Box sx={styles.dialogHeader}>
        <Typography sx={styles.dialogTitle}>専用アドレスを発行</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <EmailInboxManagement onNotify={onNotify} onIssued={onIssued} />
    </Dialog>
  );
};

export default EmailInboxManagementDialog;
